/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Einarbeitungabsolviertam2Inputs */

const de__field_einarbeitungabsolviertam2 = /** @type {(inputs: _Field_Einarbeitungabsolviertam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einarbeitung absolviert am`)
};

/**

* @param {_Field_Einarbeitungabsolviertam2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_einarbeitungabsolviertam2 = /** @type {((inputs?: _Field_Einarbeitungabsolviertam2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Einarbeitungabsolviertam2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_einarbeitungabsolviertam2(inputs)
});
export { _field_einarbeitungabsolviertam2 as "_field_einarbeitungAbsolviertAm" }